/*
 * i18n-Fallback für Preis-/Einheiten-Strings (2026-07-27).
 *
 * Problem: theme.liquid setzt window.fromPrefix / window.fromPrefixCap / window.unitLabel
 * in einem INLINE-<script>-Block (request.locale-basiert). In manchen eingeloggten/
 * Vorschau-Kontexten wird dieser Inline-Block nicht ausgeführt (z. B. CSP im Theme-Editor),
 * ohne Fehlermeldung. Dann sind diese Globals `undefined`, und die Preis-JS
 * (b2b-card-prices.js, b2b-prices.js, variant-matrix.js, checkout-gate.js) fällt auf ihre
 * deutschen Defaults ('ab '/'Ab '/'Stück') zurück → auf FR erscheint fälschlich "ab" statt
 * "dès" und "Stück" statt "pièce".
 *
 * Fix: externes Asset (wird auch geladen, wo Inline-Scripts blockiert sind) setzt die Globals
 * locale-sicher aus <html lang> — aber NUR, falls der Inline-Block sie nicht bereits gesetzt
 * hat (idempotent, kein Überschreiben). <html lang> = request.locale.iso_code, immer vorhanden.
 * Als ERSTES deferred Script laden (vor allen Preis-Consumern).
 */
(function () {
  'use strict';
  var lang = (document.documentElement.getAttribute('lang') || '').slice(0, 2).toLowerCase();
  var fr = lang === 'fr';

  if (typeof window.fromPrefix === 'undefined') {
    window.fromPrefix = fr ? 'dès ' : 'ab ';
  }
  if (typeof window.fromPrefixCap === 'undefined') {
    window.fromPrefixCap = fr ? 'Dès ' : 'Ab ';
  }
  // Anzeige-Übersetzung für Versandarten (2026-08-12), VISUAL ONLY.
  // ⚠️ Der ROHE Titel bleibt unverändert: er geht als payload.shipping.title an die Order-API,
  // landet auf dem Draft Order und wird von src/Service/Checkout/ShippingClassifier.php per
  // Keyword ausgewertet. Übersetzt wird ausschliesslich, was der Kunde liest.
  // Quelle der Namen: Shopify-Versandraten (/cart/shipping_rates.json → "Standard") und die
  // Abhol-Option des Themes. Unbekannte Raten laufen unverändert durch.
  if (typeof window.shipLabel === 'undefined') {
    window.shipLabel = function (title, key) {
      var cs = window.customStrings || {};
      var t = String(title == null ? '' : title).trim();
      if (key === 'pickup' || /^(abholung|enl(e|è)vement|pick ?up)$/i.test(t)) {
        return cs.shipPickup || t;
      }
      if (key === 'flat' || /^standard(versand)?$/i.test(t) || /^exp(e|é)dition standard$/i.test(t)) {
        return cs.shipFlat || t;
      }
      return t;
    };
  }

  if (typeof window.unitLabel === 'undefined') {
    // Nur-Anzeige-Mapping (VISUAL ONLY) — identisch zur theme.liquid-Definition.
    var map = fr ? { 'Stück': 'pièce', 'Meter': 'mètre', 'Set': 'kit', 'm': 'mètre' } : {};
    window.unitLabel = function (base) {
      return (base && map[base]) ? map[base] : base;
    };
  }
})();
